import React, { useState, useEffect } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { Colors } from "./style";
import { Button, colors, Stack, Typography, Box } from '@mui/material';
// Import di Chip da Material-UI
import { Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';

// Import delle icone da Material-UI Icons
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DescriptionIcon from '@mui/icons-material/Description';
import LanguageIcon from '@mui/icons-material/Language';
import InfoIcon from '@mui/icons-material/Info';
import PendingIcon from '@mui/icons-material/Pending';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Link } from 'react-router-dom';
import { useMemo } from 'react';
import { differenceInDays } from 'date-fns';
import './ticketsTable.css';


export default function TicketsTable({ rows, print_operator, operator_id = 0 }) {


  const [customRows, setCustomRows] = useState([]);



  const toggleTicketVisibility = async (ticket_id, visibility = 0) => {
    try {

      console.log({
        ticketId: ticket_id,
        operatorId: operator_id,
        visibility: visibility,
      })

      const response = await (await fetch("https://mapei.aion-asa.com/api/toggle_visibility_ticket_operator/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "accept": "application/json"
        },
        body: JSON.stringify({
          data: {
            ticketId: ticket_id,
            operatorId: operator_id,
            visibility: visibility,
          }
        })
      })).json()

      console.log("REPOSSNSE", response)


      if (response.code == 200) {
        setCustomRows(prev => prev.filter(item => item.ticket_id !== ticket_id))
      }

    } catch (error) {
      console.log("ERRORRE", error)
    }

  }


  // Definiamo le colonne per il DataGrid
  const getColumns = (print_operator) => {
    const baseColumns = [
      {
        field: 'ticket_id',
        headerName: 'Ticket Id',
        flex: 1,
        renderCell: (params) => (
          <Box
            onClick={() => handleRowClick(params)}
            sx={{
              height: "100%",
              width: "100%"
            }}
          >
            <Typography
              variant='body1' sx={{ color: Colors.white }}>
              {params.value}
            </Typography>
          </Box>
        ),
      },
      {
        field: 'priority',
        headerName: 'Priorità',
        flex: 0.8,
        renderCell: (params) => (
          <Box
            onClick={() => handleRowClick(params)}
            sx={{
              height: "100%",
              width: "100%"
            }}
          >
            <Typography variant='body1' sx={{ fontWeight: 'bold', color: Colors.white }}>
              {params.value}
            </Typography>
          </Box>
        ),
      },
      {
        field: 'date_open_formatted',
        headerName: 'Data Apertura',
        // flex: 1,
        width: 150,
        renderCell: (params) => (
          <Box
            onClick={() => handleRowClick(params)}
            sx={{
              height: "100%",
              width: "100%"
            }}
          >

            <Typography variant='body1' sx={{ fontWeight: 'bold', color: Colors.white }}>
              {params.value}
            </Typography>
          </Box>
        ),
      },
      {
        field: 'daysElapsed',
        headerName: 'Giorni trascorsi',
        flex: 0.8,
        renderCell: (params) => (
          <Box
            onClick={() => handleRowClick(params)}
            sx={{
              height: "100%",
              width: "100%"
            }}
          >
            <Typography variant='body1' sx={{ fontWeight: 'bold', color: Colors.white }}>
              {params.value}
            </Typography>
          </Box>
        ),
        valueGetter: (value) => {
          return value;
        },
      },
      {
        field: 'subject',
        headerName: 'Oggetto',
        flex: 1,
        renderCell: (params) => (
          <Box
            onClick={() => handleRowClick(params)}
            sx={{
              height: "100%",
              width: "100%"
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: Colors.white,
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "normal"
              }}
            >
              {params.value}
            </Typography>

          </Box>
        ),
      },
      {
        field: 'question',
        headerName: 'Descrizione',
        flex: 5,
        renderCell: (params) => (
          <Box
            onClick={() => handleRowClick(params)}
            sx={{
              height: "100%",
              width: "100%"
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: Colors.white,
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "normal"
              }}
            >
              {params.value}
            </Typography>
          </Box>
        ),
      },
      {
        field: 'user',
        headerName: 'Utente',
        flex: 1.5,
        renderCell: (params) => (
          <Box
            onClick={() => handleRowClick(params)}
            sx={{
              height: "100%",
              width: "100%"
            }}
          >

            <Typography variant='body1' sx={{ fontWeight: 'bold', color: Colors.white }}>
              {params.row.user_fullname}
            </Typography>
            <Typography variant='body2' sx={{ color: Colors.white }}>
              {params.row.user_email}
            </Typography>
          </Box>
        ),
      },
      {
        field: 'group_name',
        headerName: 'Gruppo',
        flex: 1.5,
        renderCell: (params) => (
          <Box
            onClick={() => handleRowClick(params)}
            sx={{
              height: "100%",
              width: "100%"
            }}
          >

            <Typography variant='body1' sx={{ fontWeight: 'bold', color: Colors.white }}>
              {params.row.group_name}
            </Typography>
            <Typography variant='body2' sx={{ color: Colors.white }}>
              {params.row.group_id}
            </Typography>
          </Box>
        ),
      },
      {
        field: 'aion_process_status',
        headerName: 'AION Status',
        flex: 1.8,
        renderCell: (params) => (
          <Box
            onClick={() => handleRowClick(params)}
            sx={{
              height: "100%",
              width: "100%"
            }}
          >
            <Chip
              color={
                params.value === 'solution' ? "success"
                  : params.value === 'need_info' ? 'warningOrange'
                    : 'default'
              }
              icon={
                params.value === 'solution'
                  ? <CheckCircleIcon sx={{ color: Colors.white }} />
                  : <InfoIcon sx={{ color: Colors.white }} />
              }
              label={
                params.value === 'solution'
                  ? 'Soluzione proposta'
                  : params.value === 'need_info'
                    ? 'Maggiori info'
                    : 'Da processare'
              }
              sx={{
                borderRadius: '50px',
                fontWeight: "bold",
                marginTop: "9px",
                border: '1.5px solid',
                width: "100%"
              }}
            />
          </Box>
        ),
      },
      {
        field: 'current_documents',
        headerName: 'Documenti Usati',
        flex: 1.6,
        renderCell: (params) => {
          const json_documents = JSON.parse(params.row.current_documents || '{}');

          return (
            <Box display="flex" flexDirection="column"
              onClick={() => handleRowClick(params)}
              sx={{
                height: "100%",
                width: "100%"
              }}>
              {json_documents.company_documents_used?.length > 0 && (
                <Chip
                  color='info'
                  icon={<DescriptionIcon />}
                  label="Documenti"
                  sx={{
                    borderRadius: '50px',
                    fontWeight: "bold",
                    border: '1.5px solid',
                    marginTop: "9px",
                    width: "100%",
                  }}
                />
              )}
              {json_documents.internet_documents_used?.length > 0 && (
                <Chip
                  icon={<LanguageIcon />}
                  label="Internet"
                  color='secondary'
                  sx={{
                    color: Colors.white,
                    borderRadius: '50px',
                    fontWeight: "bold",
                    border: '1.5px solid',
                    marginTop: "9px",
                    width: "100%",
                  }}
                />
              )}
            </Box>
          );
        },
      },
    ];

    // Colonna opzionale: Operatore
    const operatorColumn = {
      field: 'operator',
      headerName: 'Operatore',
      flex: 1.5,
      renderCell: (params) => (
        <Box>
          <Typography variant='body1' sx={{ fontWeight: 'bold', color: Colors.white }}>
            {params.row.operator_name} {params.row.operator_surname}
          </Typography>
          <Typography variant='body2' sx={{ color: Colors.white }}>
            {params.row.operator_email}
          </Typography>
        </Box>
      ),
    };


    // Colonna opzionale: Operatore
    const actionColumn = {
      field: 'actions',
      headerName: 'Azioni',
      flex: 1.5,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" justifyContent="center" height="100%">
          <Button
            style={{ backgroundColor: Colors.translucentBlack }}
            onClick={() => toggleTicketVisibility(params.row.id, 0)}
          >
            <Typography style={{ color: Colors.white }}>
              Nascondi
            </Typography>
          </Button>
        </Box>
      ),
    };

    // Inserisci "Operatore" prima di "Azioni"
    if (print_operator) {
      const insertIndex = baseColumns.findIndex(col => col.field === 'actions');
      baseColumns.splice(insertIndex, 0, operatorColumn);
    }

    if (!print_operator) {
      // baseColumns.push(actionColumn)
    }

    return baseColumns;
  };


  const columns = getColumns(print_operator);

  const navigate = useNavigate();

  const handleRowClick = (params) => {
    const ticketId = params.row.chat_id;  // Ottieni l'ID del ticket dalla riga
    console.log(`/Chat/${ticketId}/${operator_id}`)
    navigate(`/Chat/${ticketId}/${operator_id}`);  // Esegui il redirect al percorso desiderato
  };




  const [daysElapsedColors, setDaysElapsedColors] = useState({
    green: 2,
    yellow: 5,
    orange: 7
  })

  const getColors = async () => {
    try {
      const response = await (await fetch("https://mapei.aion-asa.com/api/get_days_elapsed_colors/", {
        method: "POST",
        headers: {
          "accept": "application/json",
          "Content-Type": "application/json",
        },
      })).json();

      console.log("RESPONSE COLORS", response);
      if (response.code === 200) {
        setDaysElapsedColors(response);
      }
    } catch (error) {
      console.log("error getting colors");
    }

  }

  useEffect(() => {
    getColors()
  }, [])



  const getRowClassName = (params) => {
    // Imposta una classe in base ai giorni trascorsi
    if (params.row.daysElapsed <= daysElapsedColors.green) return 'ticket-green';
    if (params.row.daysElapsed <= daysElapsedColors.yellow) return 'ticket-yellow';
    if (params.row.daysElapsed <= daysElapsedColors.orange) return 'ticket-orange';
    return 'ticket-red'; // Più di 15 giorni
  };




  useEffect(() => {
    if (rows) {
      const processed = rows.map(row => {
        const dateOpen = row.date_open ? new Date(row.date_open) : new Date();
        const daysElapsed = differenceInDays(new Date(), dateOpen);
        return {
          ...row,
          daysElapsed,
        };
      });
      setCustomRows(processed);
    }
  }, [rows]);



  return (
    <div style={{ width: '100%' }}>
      <DataGrid
        initialState={{
          sorting: {
            sortModel: [{ field: 'daysElapsed', sort: 'asc' }],
          }
        }}
        rows={customRows}
        columns={columns}
        style={{
          height: "fit-content"
        }}
        rowsPerPageOptions={[5]}
        // onRowClick={handleRowClick}
        getRowClassName={getRowClassName}
        // getRowHeight={() => 'auto'} // Calcola l'altezza in base al contenuto
        rowHeight={90} // Altezza minima della riga per garantire la visibilità di 3 linee di testo
        sx={{
          '& .MuiDataGrid-container--top': {
            backgroundColor: 'rgba(255,255,255,0.2)',
          },
        }}
      />
    </div>
  );
};
